module.exports = __webpack_public_path__ + "static_pc/img/af1.ef19905a.png";